import { render } from "./OptionBarGroup.vue?vue&type=template&id=77660ef6&scoped=true"
import script from "./OptionBarGroup.vue?vue&type=script&lang=js"
export * from "./OptionBarGroup.vue?vue&type=script&lang=js"

import "./OptionBarGroup.vue?vue&type=style&index=0&id=77660ef6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77660ef6"],['__file',"src/scripts/common/sideBars/components/OptionBarGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77660ef6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77660ef6', __exports__)) {
    api.reload('77660ef6', __exports__)
  }
  
  module.hot.accept("./OptionBarGroup.vue?vue&type=template&id=77660ef6&scoped=true", () => {
    api.rerender('77660ef6', render)
  })

}


export default __exports__